import http from "../../http";
import { API_URLs } from "../../CONSTANTS";

const profile_apis = API_URLs.profile;

export const apiCall_getProfile = async () => {
  return http.get(profile_apis.getProfileData);
};

export const apiCall_editProfile = async (frmData) => {
  console.log(frmData);
  return http.post(profile_apis.editProfile, frmData);
};

export const apiCall_getAccountStatus = async (statusNumber) => {
  return http.get(
    profile_apis.getStoreAccountStatus + "?status=" + statusNumber
  );
};
